<template>
  <div>
    <van-row class="flex">
      <van-col :span="spanCityLeft" class="cityElement" @click="cityShow">
        <span class="cityText" v-text="city"></span>
        <van-icon name="play" class="play" />
      </van-col>
      <van-col :span="spanCityCenter">
        <form action="/" style="width：100%">
          <van-search
            class="search"
            v-model="value"
            show-action
            :placeholder="placeholderText"
            @cancel="onCancel"
            @input="showCityInfo"
            id="seekInput"
          />
        </form>
      </van-col>
    </van-row>
    <!-- 搜索地址 -->
    <div class="searchContainer" v-if="!cityOrSearch">
      <van-list>
        <van-cell v-for="(item,index) in addressList" :key="index" v-show="item.location">
          <template>
            <div slot-default="item" @click="positionFun(item)">
              <van-row class="flexItem">
                <van-col push="1" span="1">
                  <van-image width="11" height="11" :src="imgTime" v-if="inputState==='start'" />
                  <van-image width="9" height="12" :src="imgPosition" v-else />
                </van-col>
                <van-col span="23">
                  <span v-text="item.name" class="text3"></span>
                  <br />
                  <span v-show="item.district!==''" v-text="item.district"></span>
                  <span v-show="item.address.length!==0" v-text="item.address"></span>
                </van-col>
              </van-row>
            </div>
          </template>
        </van-cell>
      </van-list>
    </div>
    <!-- 城市选择 -->
    <div class="city-container" v-if="cityOrSearch">
      <van-index-bar :index-list="indexList">
        <van-index-anchor class="city-Top-Title">
          <van-icon name="fire" />开通城市
        </van-index-anchor>
        <div  v-if='cityText.length>0'>
        <van-index-anchor v-for="(items,indexs) in cityText" :index="indexs" :key="indexs">
          <div class="city-border" @click="cityEventFun(items.name,items.code)">{{items.name}}</div>
        </van-index-anchor>
        </div>
       <div v-else class="no-city">暂未开能城市</div>
      </van-index-bar>
    </div>

    <div class="historyContainer" v-if='historyShow'>
      <van-list>
        <div class="center history-record"  >历史记录</div>
        <van-cell v-for="(item,index) in historyArray" :key="index" @click='historyFun(item)' >
          <template>
            <div slot-default="item">
              <van-row class="flexItem">
                <van-col push="1" span="1">
                  <van-image width="11" height="11" :src="imgTime" v-if="inputState==='start'" />
                  <van-image width="9" height="12" :src="imgPosition" v-else />
                </van-col>
                <van-col span="23">
                  <span class="text3">{{item.end}}</span>
                  <br />
                  <span>{{item.district}}</span>
                  <span>{{item.address}}</span>
                </van-col>
              </van-row>
            </div>
          </template>
        </van-cell>
      </van-list>
    </div>

    <div id="container" style="display:none"></div>
  </div>
</template>
<script>
import { Toast } from "vant";
import AMap from "AMap";
import { getAreaListFun } from "@/api/home.js";
import { setHistory, getHistory } from "@/utils/auth.js";
export default {
  name: "Location",
  data() {
    return {
      indexList: [],
      spanCityLeft: 3, 
      spanCityCenter: 19,
      imgTime: require("../../assets/map/time.png"),
      imgPosition: require("../../assets/map/position.png"),
      value: "",
      //地图
      map: "",
      city: "城市",
      center: "",
      //搜索地址
      addressList: "",
      placeholderText: "您在那儿上车",
      //用户选择的地址状态
      inputState: this.$route.query.inputState,
      cityText: null,
      elementHeight: null,
      //控制显示城市名与搜索内容
      cityOrSearch: false,
      //历史记录
      historyArray: [],
      historyShow:true
    };
  },
  created() {
    //历史记录
    let getHis = getHistory()
    if(getHis){
      this.historyArray = JSON.parse(getHis)
    }else{
      this.historyShow = false
    }
    
    getAreaListFun().then(res => {
      if(res.data.data.length>0){
        this.cityText = res.data.data;
      }
    });

    this.elementHeight =
      document.documentElement.clientHeight || document.body.clientHeight;
    /**
     * 判断用户是否有城市名
     *
     */
    if (
      this.inputState === "start" &&
      this.$store.state.userBusRoute.startCity !== ""
    ) {
      this.city = this.$store.state.userBusRoute.startCity;

      this.cityOrSearch = false;
    } else if (
      this.inputState === "end" &&
      this.$store.state.userBusRoute.endCity !== ""
    ) {
      this.city = this.$store.state.userBusRoute.endCity;
      this.cityOrSearch = false;
    }
    this.cityLengthFun(this.city);

    /*
      input 
             this.placeholderText='您在那儿上车'
    */
    if (this.inputState === "start") {
      this.placeholderText = "您在那儿上车";
    } else {
      this.placeholderText = "请搜索您的目的地";
    }
  },
  mounted() {
    this.initMap();
    //this.showCityInfo();
  },

  methods: {
    onCancel() {
      this.$router.go(-1)
     // this.$router.push({ name: "Home" });
    },
    initMap() {
      this.map = new AMap.Map("container", {
        resizeEnable: true,
        zoom: 10
      });
    },
    showCityInfo() {
      let self = this;
      var keywords = document.getElementById("seekInput").value;
      if (!this.value && self.city !== "城市") {
        keywords = self.city;
      }
      if (self.city === "城市") {
        return Toast("请先选择城市");
      } else {
        this.cityOrSearch = false;
      }
      AMap.plugin("AMap.Autocomplete", function() {
        // 实例化Autocomplete
        var autoOptions = {
          city: self.city,
          // datatype:"all",   //回所有数据类型
          citylimit: true //强制限制在设置的城市内搜索
        };
        var autoComplete = new AMap.Autocomplete(autoOptions);
        autoComplete.search(keywords, function(status, result) {
          if (result.info === "OK" && status === "complete") {
            self.addressList = result.tips;
          } else {
            self.finished = true;
          }
        });
      });
    },
    positionFun(value) {

      /**
       * 
       * 
       * 将用户的乘车信息保存到全局
       * 方便首页与定位页面使用
       * 
       */
       this.$store.state.TAG = 'NoAppPosition'
      let cityStyle = ''
      let userBusRoute = this.$store.state.userBusRoute;
      if (this.inputState === "start") {
        cityStyle =  this.$store.state.userBusRoute.startCity
        //起点
        userBusRoute.start = value.name;
        userBusRoute.startAdcode = value.adcode;

        userBusRoute.startLat = value.location.lat;
        userBusRoute.startLon = value.location.lng;
      } else if (this.inputState === "end") {
        cityStyle =  this.$store.state.userBusRoute.endCity
        //终点
        userBusRoute.end = value.name;
        userBusRoute.endAdcode = value.adcode;

        userBusRoute.endLat = value.location.lat;
        userBusRoute.endLon = value.location.lng;
      }
      //历史记录
       let arr = {
          end: value.name,
          endAdcode: value.adcode,
          endCity: cityStyle,
          address: value.address,
          district: value.district,
          endLat: value.location.lat,
          endLon: value.location.lng
        };
        this.historyArray.unshift(arr);
        let Duplicates =    this.historyArray.reduce((previousValue,currentValue)=>{
          previousValue[currentValue.address] ? '' : previousValue[currentValue.address] = true && previousValue.push(currentValue);
         return previousValue
        },[])
         if(Duplicates.length>=10){
          Duplicates.splice(10)
         }
        setHistory(Duplicates); 
      //
      this.$store.commit("UpdataStart", userBusRoute);
     
      this.$router.replace({path:'/'})

       //this.$router.go(-1)
     // this.$router.push({ name: "Home" });
    },
    cityEventFun(city) {
      this.cityLengthFun(city);
      if (this.inputState === "start") {
        this.$store.state.userBusRoute.startCity = city;
        this.$store.commit("UpdataStart", this.$store.state.userBusRoute);
      } else if (this.inputState === "end") {
        this.$store.state.userBusRoute.endCity = city;
        this.$store.commit("UpdataStart", this.$store.state.userBusRoute);
      }
      this.city = city;
      this.cityOrSearch = false;
    },
    cityShow() {
      this.cityOrSearch = true;

      this.historyShow = false;
    },
    cityLengthFun(city) {
      if (city.length > 3 && city.length < 5) {
        this.spanCityCenter = 20;
        this.spanCityLeft = 4;
      } else if (city.length == 5) {
        this.spanCityCenter = 19;
        this.spanCityLeft = 5;
      } else if (city.length > 5) {
        this.spanCityCenter = 16;
        this.spanCityLeft = 8;
      } else if (city.length == 3) {
        this.spanCityCenter = 20;
        this.spanCityLeft = 4;
      } else if (city.length < 3) {
        this.spanCityCenter = 21;
        this.spanCityLeft = 3;
      }
    },
    //历史记录
    historyFun(item){
      this.$store.state.TAG = 'NoAppPosition'
      let userBusRoute = this.$store.state.userBusRoute;
      if(this.inputState === "start"){
        userBusRoute.startCity = item.endCity
        userBusRoute.start = item.end;
        userBusRoute.startAdcode = item.endAdcode;

        userBusRoute.startLat = item.endLat;
        userBusRoute.startLon = item.endLon;
      }else if(this.inputState === "end"){
         //终点
        userBusRoute.endCity = item.endCity
        userBusRoute.end = item.end;
        userBusRoute.endAdcode = item.endAdcode;

        userBusRoute.endLat = item.endLat;
        userBusRoute.endLon = item.endLon;
      }
       this.$store.commit("UpdataStart", userBusRoute);
      
       
        this.$router.replace({name:"Home"})
      //this.$router.go(-1)
      // this.$router.push({ name: "Home" });
    }
  }
};
</script>
<style lang="scss" scoped>
$gray32: #323233;
$grayEB: rgba(235, 237, 240, 0.5);
$gray9: #999999;
.flex {
  border-bottom: 1px solid $grayEB;
  padding-left: 15px;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 100;
  background: #fff;
  .cityElement {
    height: 100%;
    display: flex;

    .cityText {
      text-align: center;
      font-size: 0.8rem;
      color: $gray32;
    }
    .play {
      transform: rotate(90deg);
      font-size: 10px;
      color: $gray32;
    }
    .van-search--show-action {
      padding: 0;
    }
  }
  .search {
    padding-left: 0;
    padding-right: 0;
  }
}
#container {
  box-sizing: border-box;
  position: absolute;

  width: 0;
  height: 0;
}
.van-cell::after {
  left: 0;
}
.searchContainer,
.historyContainer {
  padding-top: 125px;
  overflow: auto;
  .history-record{

    margin-top:10px;
    color:$gray32;
    font-size: 32px;
    line-height: 80px;
    border-bottom:1px solid $grayEB
  }
  .flexItem {
    display: flex;
    align-items: center;
    color: $gray9;
    font-size: 24px;
    .text3 {
      font-size: 30px;
      color: $gray32;
    }
  }
}
.historyContainer {
  padding-top: 0;
}
.city-border {
  border-bottom: 1px solid $grayEB;
  line-height: 100px;
}
.city-container {
  padding-top: 128px;
  z-index: 1;
  .no-city{text-align: center;color:$gray9;font-size: 32px;line-height: 100px;}
  .city-Top-Title {
    border-bottom: 1px solid $grayEB;
    background: rgba(235, 237, 240, 0.2);
    .van-index-anchor {
      line-height: 180px;
     
    }
  }
}
</style>